import React, { useState, useEffect } from "react";
// import AddEditModule from '../../component/AddEditModuleComponent/AddEditModule'
import Header from "../../../component/Header/Header";
import { useParams } from "react-router-dom";
import Footer from "../../../component/Footer/Footer";
import Sidebar from "../../Sidebar";
import { Image_Url } from "../../../constants/imageUrl/ImageUrl";
import "./Addmoduleconfirmation.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineSearch } from "react-icons/ai";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const AddModuleConfirmation = () => {
  const [selectedCheckbox, setSelectedCheckbox] = useState("checkbox1");
  const moduledata = useSelector((state) => state?.modulecreated);
  const handleCheckboxChange = (event) => {
    setSelectedCheckbox(event.target.value);
  };
  const navigate = useNavigate();
  const oncreateMore = () => {
    navigate("/addeditmodule");
  };


  const [currentDate, setCurrentDate] = useState(new Date());
  const { id } = useParams();
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const onclickEdit = () =>{
    navigate(`/editmodule/${id}`);
  }
  useEffect(() => {
    handleChangeLanguage(language);
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update the date every second

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);
  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const options = {
    // weekday: "long",
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  const formattedDate = currentDate.toLocaleDateString(undefined, options);
  const CurrentDate=moment().format(formattedDate,'YYYY MMMM Do')

  return (
    <div className="AddModuleConfirmation_containers">
      <div className="AddModuleConfirmation_container">
        <div className="AddModuleConfirmationcontent">
          <div className="header_border">
            TVS &gt; {t('sidebar.producttraining')} &gt; {t('add_module.module')} &gt; {t('add_module.createModuleButton')}
          </div>
          <div className="AddModuleConfirmation_panel">
            <div className="panel-all">{t('add_module.addeditmodule')}</div>
          </div>
          <div className="hero-section">
            <div className="panel-text">
              {t('add_module.congratulationcreatemodule')}
              <button
                className="Addmodelcreation_create"
                onClick={oncreateMore}
              >
                {t('add_module.createmore')}
              </button>
            </div>
            <div className="confirmation-content-box">
              <div className="content-heading">
                {moduledata?.moduleList?.data?.name}
                <div className="content-edit" onClick={onclickEdit}>{t('partlist.edit')}</div>
              </div>
              <div className="confirmation-date">
                <ruby className="panel-date">
                  {CurrentDate}
                  <rt className="panel-dateHead">{t('add_module.date')}: </rt>
                </ruby>
              </div>
              <hr />
              {moduledata?.moduleList?.data?.training_list.map((data, i) => (
                <div className="main-content">
                  <div className="main-image">
                    <img
                      alt="img"
                      height="66px"
                      width="108px"
                      src={
                        data.video_thumbnail
                          ? data.video_thumbnail
                          : Image_Url.THUMBNIL2
                      }
                    />
                  </div>
                  <div className="text-content">
                    <div className="text-content1">{data.title}</div>
                    <p className="text-content2">{data.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="footer_div">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddModuleConfirmation;
